import { useMutation, gql } from '@apollo/client';
import {
  EditarOfertaMutation,
  EditarOfertaMutationVariables,
} from './__generated__/EditarOfertaMutation';

const EDITAR_OFERTA_MUTATION = gql`
  mutation EditarOfertaMutation(
    $id_oferta: Int!
    $num_ano: Int
    $num_oferta: Int
    $num_semestre: Int
    $id_assistente: Int
    $dat_inicio: String
    $dat_fim: String
    $ativa: Boolean!
  ) {
    editarOferta(
      input: {
        id_oferta: $id_oferta
        num_ano: $num_ano
        num_oferta: $num_oferta
        num_semestre: $num_semestre
        id_assistente: $id_assistente
        dat_inicio: $dat_inicio
        dat_fim: $dat_fim
        ativa: $ativa
      }
    ) {
      id_oferta
      num_oferta
      num_ano
      num_semestre
      ativa
      id_assistente
      assistente {
        id_assistente
        dsc_nome
        dsc_email
      }
      dat_inicio
      dat_fim

      turmas {
        id_turma
        id_horario
        num_turma
        dias_semana
        ativa
      }
    }
  }
`;

const useEditarOfertaMutation = () => {
  return useMutation<EditarOfertaMutation, EditarOfertaMutationVariables>(EDITAR_OFERTA_MUTATION);
};

export { useEditarOfertaMutation };
